import { NgModule } from '@angular/core';
import { AvoidCopyPasteDirective } from './avoid-copy-paste/avoid-copy-paste';
import { AvoidSpecialCharsDirective } from './avoid-special-chars.directive';
import { ClickOutsideDirective } from './click-outside/click-outside';
import { OnlyNumbersDirective } from './only-numbers.directive';
import { StopClickDirective } from './stop-click.directive';
import { StopKeydownDirective } from './stop-keydown.directive';
import { AgStickyHeaderDirective } from './ag-sticky-header.directive';
import { MiqTooltipDirective } from '@cbre/components';

@NgModule({
  imports: [MiqTooltipDirective],
  exports: [
    MiqTooltipDirective,
    AvoidSpecialCharsDirective,
    AvoidCopyPasteDirective,
    StopClickDirective,
    StopKeydownDirective,
    OnlyNumbersDirective,
    ClickOutsideDirective,
    AgStickyHeaderDirective,
  ],
  declarations: [
    AvoidSpecialCharsDirective,
    AvoidCopyPasteDirective,
    StopClickDirective,
    StopKeydownDirective,
    OnlyNumbersDirective,
    ClickOutsideDirective,
    AgStickyHeaderDirective,
  ],
  providers: [],
})
export class DirectivesModule {}
